import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchBlog } from "@/lib/api";
import { SITE_URL } from "@/lib/site";
import SEO from "@/components/SEO";

export default function Blog() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    fetchBlog().then(setPosts).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const blogJsonLd = {
    "@context": "https://schema.org",
    "@type": "Blog",
    name: "Weight Loss Gurukul Journal",
    url: `${SITE_URL}/blog`,
    publisher: { "@type": "Organization", name: "Weight Loss Gurukul" },
  };

  return (
    <div data-testid="blog-page" className="section-pad">
      <SEO
        title="Best Yoga for Weight Loss — Practical Guides & Articles | Weight Loss Gurukul Journal"
        description="Evidence-backed guides on the best yoga for weight loss, pranayama, surya namaskar, yoga nidra and the Krishnamacharya lineage. Practical articles from Dhruva Lingappa and the Weight Loss Gurukul team."
        path="/blog"
        keywords="best yoga for weight loss, yoga blog, weight loss tips, surya namaskar weight loss, pranayama for belly fat, yoga nidra weight loss, vinyasa krama yoga"
        jsonLd={blogJsonLd}
      />
      <div className="container-x">
        <div className="max-w-2xl">
          <p className="eyebrow">Journal</p>
          <h1 className="mt-3 font-serif text-5xl md:text-6xl text-forest leading-tight">
            Wisdom from the mat. Backed by science.
          </h1>
          <p className="mt-6 text-lg text-ink-soft">
            Deep dives on yoga, Ayurveda, nutrition, and mindful living. Read what
            we teach our clients every day.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {posts.map((p) => (
            <Link key={p.slug} to={`/blog/${p.slug}`} data-testid={`blog-page-card-${p.slug}`} className="group rounded-3xl overflow-hidden border border-sand-300 bg-white hover:shadow-xl transition-all hover:-translate-y-1">
              <div className="aspect-[16/10] overflow-hidden">
                <img src={p.cover} alt={p.title} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-700" />
              </div>
              <div className="p-6">
                <div className="flex flex-wrap gap-2">
                  {p.tags.slice(0, 2).map((t) => <span key={t} className="text-xs px-2 py-1 rounded-full bg-sand-200 text-forest">{t}</span>)}
                </div>
                <h2 className="mt-3 font-serif text-2xl text-forest group-hover:text-clay transition-colors leading-tight">{p.title}</h2>
                <p className="mt-2 text-sm text-ink-soft line-clamp-2">{p.excerpt}</p>
                <div className="mt-4 text-xs text-ink-muted">{new Date(p.date).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })} · {p.read_time}</div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
